import Link from "next/link";
import { ReactNode } from "react";

const Pager = ({ to, value, active = false }: PagerProps) => {
  const className = ["page-item", active ? "active disabled" : ""].join(" ");

  return (
    <li className={className}>
      <Link href={to} className="page-link text-nowrap">
        {value}
      </Link>
    </li>
  );
};

interface PagerProps {
  to: string;
  value: string | ReactNode;
  active?: boolean;
}

export default Pager;
